import { render, staticRenderFns } from "./okbaoCheck.vue?vue&type=template&id=1d0839cb&scoped=true"
import script from "./okbaoCheck.vue?vue&type=script&lang=js"
export * from "./okbaoCheck.vue?vue&type=script&lang=js"
import style0 from "./okbaoCheck.vue?vue&type=style&index=0&id=1d0839cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0839cb",
  null
  
)

export default component.exports